import { Component, Injector } from '@angular/core';
import { SmtService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../filterable-service';

@Component({
  selector: 'app-smt',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class SmtComponent extends BaseGridComponent {
  private readonly gaSmtService: SmtService;
  private readonly parentSMTDescriptionService = new FilterableService();

  public descMaxLength: number = null;
  public identifierMaxLength: number = null;
  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: SmtService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.gaSmtService = injector.get(SmtService);
    this.descMaxLength = 50;
    this.identifierMaxLength = 3;
    this.appCardTitle = 'SMTs';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Identifier',
        title: 'Identifier',
        editor: 'number',
        filter: 'numeric'
      },
      {
        field: 'Description',
        title: 'Description',
      },
      {
        field: 'ParentSMTDescription',
        title: 'Parent Description',
        type: 'dropdown',
        service: this.parentSMTDescriptionService,
        textField: 'Description',
        valueField: 'Id',
        name: 'SMTReferenceId',
        refreshSecondaryData: this.populateSMTParentList,
        valueChange: this.handleValueChange
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Identifier: ['', Validators.compose([Validators.required, Validators.pattern('[0-9]*'), Validators.max(999)])],
      Description: ['', Validators.required],
      SMTReferenceId: [],
      IsActive: [],
      ParentSMTDescription: [],
      AuditDto: []
    });
  }

  populateSMTParentList(dataItem: any) {
    dataItem.gaSmtService.read('/?activeOnly=true')
    .then(result => {
      if (result.length > 0) {
        result = result.sort((a, b) => a.Description.localeCompare(b.Description));
      }
      result.unshift({Id: null});
      dataItem.parentSMTDescriptionService.next(result);
    });
  }

  handleValueChange(value: any, dataItem: any) {
    if (value === null) {
      dataItem.editForm.get('ParentSMTDescription').reset();
    }
  }
}
